import { ApplicationEnum } from "../types";
import { PlatformV1RequestService, PlatformV2RequestService, SeamlessRequestService } from "./index";
export class RequestServiceFactory {
    static getRequestService(applicationType, apiVersion, anonymousApiUrl, siteID, OperatorAuthTokenId, ajaxService) {
        switch (applicationType) {
            case ApplicationEnum.Platform:
                switch (apiVersion.toLowerCase()) {
                    case "v1":
                        return new PlatformV1RequestService(anonymousApiUrl, siteID, ajaxService);
                    case "v2":
                        return new PlatformV2RequestService(anonymousApiUrl, siteID, ajaxService);
                    default:
                        throw `Not supported api version: ${apiVersion}`;
                }
            case ApplicationEnum.Seamless: {
                return new SeamlessRequestService(anonymousApiUrl, OperatorAuthTokenId, ajaxService);
            }
            default:
                throw `Not supported application type: ${applicationType}`;
        }
    }
}
//# sourceMappingURL=RequestServiceFactory.js.map